import { render, staticRenderFns } from "./CompanyEditor.vue?vue&type=template&id=af81772e&scoped=true"
import script from "./CompanyEditor.vue?vue&type=script&lang=js"
export * from "./CompanyEditor.vue?vue&type=script&lang=js"
import style0 from "./CompanyEditor.vue?vue&type=style&index=0&id=af81772e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af81772e",
  null
  
)

export default component.exports